import { buildPath } from "../../../helpers/string";
import { PermissionEnum } from "../../../modules/permission/enum";
import { root } from "./root";

export const intakes = {
  path: "intakes",
  getLink: () => buildPath([root.path, intakes.path]),
  permissions: [PermissionEnum.ENROLLMENT_MANAGEMENT_ACCESS],
  intakeDetails: {
    path: ":intakeId",
    getLink: (intakeId: string | number) => buildPath([intakes.path, intakeId.toString()]),
    permissions: [PermissionEnum.ENROLLMENT_MANAGEMENT_ACCESS],
  },
};
